import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, HostListener, ChangeDetectorRef, ViewEncapsulation, Renderer2} from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { AuthenticationService, ValidationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { ProductSelectionService } from './product-selection.service';
import { ProductSelectionModel, MdmDetails } from './product-selection.modal';

import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { FormBuilderService } from 'lib/ng2-sapmp/src/ui-components/form-builder/form-builder.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
import { TERMSCONDITIONS } from 'config';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config';
import { interval, of, Subject } from 'rxjs';
import { exhaustMap, filter, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { error, timeStamp } from 'console';
import { SignupSetupService } from '../signup-setup/shared/providers/signup-setup.service';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';

declare var logoutCurrentUser: any;
export const ESCAPE_KEY = 27;
declare var ENV_PORTAL: any;

@Component({
  selector: 'app-product-selection',
  providers: [ValidationService, ProductSelectionService, FormBuilderService, SignupSetupService, StepIndicatorService],
  templateUrl: './product-selection.component.html',
  styleUrls: ['./product-selection.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductSelectionComponent implements OnInit {
  header: string;
  isDataAvailable: boolean;
  initModal: boolean;
  showOverviewModal: boolean;
  permissionLevelMessage: string;
  eventEmit: any;
  modalClass: string;
  focusabbleElements: any;
  faqDetails: any;
  helpArticles: any;
  isMobile: boolean;
  errorMessage: any;
  signUpStatus: any;
  productSelectionModel: ProductSelectionModel;
  productSelection: any;
  mdmDetails: MdmDetails;

  tcUrl: any;
  //tcUrlIbm: any;
  staticTcUrl: any;

  userSelection: any; // UserSelectionModel
  selectMdm: FormGroup;
  selectService: FormGroup;
  errorMsg = '';
  user: any;
  agreementID: any;
  breadCrumbs: BreadCrumbModel[];
  previousRoute: any;
  pivots: Array<MobilePivotModel>;
  csrPermissionSignUpButton: boolean;
  showGoogleCreationError: any;
  setupError = false;
  numericSearch: boolean;
  selectedMdmDetails: any;
  selectedAccID: any;
  emmProductCode: any;
  preSelectedMdmselect: any;
  preSelectedMdmDetail: any;
  preSelectedMdm = false;
  preSelectedMdmIbm = false;
  pereSelGoogleValue: any;
  googleValue: any;
  googleIdValue: any;
  googleValueConfirm: any;
  samsungValue: any;
  appleValue: any;
  appleValue1: any;
  abmOrgIdWarningMessage: any;
  isSamsungDisable = false;
  isGoogleDisable = false;
  isAppleDisable = false;
  selectedRadio: boolean;
  //selectedRadioIBM: boolean;
  selectedRadioGoogle: boolean;
  selectedRadioSamsung: boolean;
  selectedRadioApple: boolean;
  userDetail: any; // for demo purpose till the backend service is ready.
  productSignupStatus: any;
  otherProductsSelection: any;
  parentemmAccountId: any;
  childemmAccountId: any;
  selectedDetails: any;
  selectedDetailsKme: any;
  selectedDetailsAbm: any;
  signupEmmStatus: any;
  selectedValuesSession: any;
  tncUrl: string;
  manageProduct: any;
  sessionMdmDetails: any;
  preSelectedEmm: any;
  fanProductData: any;
  callSamsung: boolean = true;
  callApple: boolean = true;
  productSelectionStatus: any; // can be any of these 3 newSetupFanList ,revisedFanList ,awaitingSignupFanList
  showZTPProductInfoModal: boolean = false;
  showKMEProductInfoModal: boolean = false;
  confirmModalPopup: ConfirmModalPopupModel;
  public: ConfirmModalPopupModel;
  public showZTPProductInfoPopup: ConfirmModalPopupModel;
  public showKMEProductInfoPopup: ConfirmModalPopupModel;
  abmflag: boolean = false;
  ztpselected: boolean = false;
  kmeselected: boolean = false;
  abmselected: boolean = false;
  setupZteError: boolean = false;
  MdmSelection: string;
  selected: boolean = false;
  show: boolean = false;
  sessionData: any;
  notequalError: boolean = false;
  notequalErrorMessage: string;
  tranid: any;
  showABMFEOption: boolean = false;
  profileAndPermsInfo: any;
  FirstName: any;
  LastName: any;
  Role: any;
  Email: any;
  isABMCI_PermissionGrant: boolean = false;
  appleDEPCallFailed: boolean = false;
  appleDEPerrorMessage: string;
  googleIderrorMessage: string;
  status: boolean = false;
  abmOrgIdValidationError: string;
  orgIdValidationLoading: boolean = false;
  romeCallFailed: boolean = false;
  showZTECustModal: boolean = false;
  setABMdefault: any;
  selectedResponseOption: string;
  hideTextBox: boolean = false;
  generalDescription: boolean = false;
  // selectService: FormGroup;
  responseOptionControl: FormControl;
  isMobileView: boolean = window.innerWidth <= 768;
  abmRadioSelected: string;
  zteRadioSelected: string;
  resellerId: any;
  zteResellerId: any;
  kmeResellerId: any;
  showABMYesContent: boolean = false;
  isABMTooltipVisible: boolean = false;
  copiedResellerId: boolean = false;
  showABMOrgIdPage: boolean = false;
  showABMNoContent: boolean = false;
  showConfirmationPopup: boolean = false; 
  isConfirmErrorChecked: boolean = false;
  processSignup: boolean = false;
  showFanSelectionPage: boolean = false;
  zteYesStep1: boolean = false;
  zteYesStep2: boolean = false;
  zteYesStep3: boolean = false;
  zteNoStep2: boolean = false;
  zteNoStep3: boolean = false;
  setupError2: boolean = false;
  isAdminPortal: boolean = false;
  showABMMaybeContent: boolean = false;
  abmOrgIdWarning: boolean = false;
  // till the back and service is ready we wil be mocking the data

  // setValue() { this.MdmSelection = 'true'; }
  @ViewChild('accessModal') accessModal: ElementRef;

  modelSelection = { MdmSelectionOptions: 'Google' };
  formErrors = {
    'googleIdName': '',
    'samsungIdName': '',
    'appleIdName': '',
    'appleIdName1': '',
    'MdmSelection': '',
    'googleIdNameConfirm': '',
    'googleIdZteName': '',
    'googleIdNameZteConfirm': ''
  };

  validationMessages = {
    'googleIdName': {
      'required': 'Enter a valid Google email address',
      'pattern': 'Email address is not associated with Google, please enter a Google associated email address.'
    },
    'samsungIdName': {
      'required': 'Samsung ID is required.',
      'pattern': 'Please enter a valid Samsung ID.'
    },
    'appleIdName': {
      'required': 'Apple Org ID is required.',
      'pattern': 'Please enter a valid Apple Org ID.'
    },
    'appleIdName1': {
      'required': 'Apple Org ID is required.',
      'pattern': 'Please enter a valid Apple Org ID.'
    },
    'MdmSelection': {
      'required': 'Value is required.',
      'pattern': 'Please enter a valid value.'
    },
    'googleIdNameConfirm': {
      'required': 'Enter a valid Google email address',
      'pattern': 'Email address is not associated with Google, please enter a Google associated email address.'
    },
    'googleIdZteName': {
      'required': 'Customer ID is required.',
      'pattern': 'Please enter a valid Customer ID.'
    },
    'googleIdNameZteConfirm': {
      'required': 'Customer ID is required.',
      'pattern': 'Please enter a valid Customer ID.'
    }

  };
  timerStart: any;
  selectedProd: any;
  isDisable: boolean;
  flagToRemoveCache: boolean = false;
  reenrollflag: boolean = false;
  failFromReviewFlag: string;
  abmFeFlag: boolean;
  orgIdValidationLoadingPopupMessage: string = '';
  ABMFECI: boolean = true;
  showErrors: boolean = false;
  isPasswordSame: boolean;
  checkTransactionMock: boolean = false;
  abmOrgIdValidationTimeOutError: string = '';
  disableZTE: boolean = false;
  disableKME: boolean = false;
  disableABM: boolean = false;
  appleDEPFANs: any = [];
  isABMFE: boolean = false;
  companyName: String = "";
  companyDomain: String = "";
  companyAddress: String = "";
  primaryEmail: String = "";
  abmNoStep2: boolean = false;
  abmNoStep3: boolean = false;
  abmNoStep4: boolean = false;
  IFDMock: boolean = false; // Mock for IFD call, set to true for testing purposes
  continueBtnDisable: boolean = false;
  receivedParams: any;
  showBackButton: boolean = true;
  kmeYesStep1: boolean = false;
  kmeYesStep2: boolean = false;
  kmeYesStep3: boolean = false;
  kmeYesStep4: boolean = false;
  abmYesFlow: boolean = false;
  kmeRadioSelected: string;
  kmeNoStep1: boolean = false;
  zteNoFlow: boolean = false;
  showDisableTooltip: boolean = false;
  targetDivStyle: any;
  appleOrgIdError: any;
  tooltipTimeout: any = null;
  isTooltipVisible: boolean = false;
  activeTooltipElement: HTMLElement | null = null;
  isABMFanAvailable: boolean = true;
  isZTEFanAvailable: boolean = true;
  isKMEFanAvailable: boolean = true;

  @ViewChild('sourceZTEDiv') sourceZTEDiv: ElementRef;
  @ViewChild('sourceKMEDiv') sourceKMEDiv: ElementRef;
  @ViewChild('sourceABMDiv') sourceABMDiv: ElementRef;
  @ViewChild('targetDiv') targetDiv: ElementRef;

  // private stopPolling$ = new Subject<void>();
  private stopPolling$;
  
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.mobileView();
  }

  constructor(private cdRef: ChangeDetectorRef, private utilityService: UtilityService, private router: Router,
    private productSelectionService: ProductSelectionService, private breadCrumbService: BreadCrumbService, private el: ElementRef,
    private formBuilder: FormBuilder, private validationService: ValidationService, private route: ActivatedRoute,
    private pageloaderService: PageLoaderService, private adobeAnalyticsService: AdobeAnalyticsService, private authenticationService: AuthenticationService, private signupSetupService: SignupSetupService) {
    this.mdmDetails = new MdmDetails();
    this.isDataAvailable = false;
    this.faqDetails = [];
    this.numericSearch = true;
    this.selectedValuesSession = JSON.parse(sessionStorage.getItem('savedSelectedDetails'));
    this.sessionMdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    this.childemmAccountId = [];
    this.appleDEPerrorMessage = "We are experiencing an issue, please try again later or contact your account representative for support.";
    this.googleIderrorMessage = "Zero-touch customer ID not found. Please add AT&T as a reseller in your Zero-touch portal prior to sign up.";
    this.orgIdValidationLoadingPopupMessage = "We are validating your Apple Organization ID. This may take several minutes.";
    
    let accountSummaryData = sessionStorage.getItem('accountSummaryData') ? JSON.parse(sessionStorage.getItem('accountSummaryData')) : null;
    if(accountSummaryData && accountSummaryData.allFansInEligible) {
      this.router.navigate(['errorPage', '408']);
    }
  }

  ngOnInit() {
    // const currentNavigation = this.router.getCurrentNavigation();
    // if (currentNavigation && currentNavigation.extras.state) {
    //   let receivedData = currentNavigation.extras.state;
    //   console.log('Received data:', receivedData);
    //   // You can now use this.receivedData in your component
    // }
    // document.title = 'Product selection';
    //location.reload(true);

    if (ENV_PORTAL === "dmpadmin" ) {
      this.isAdminPortal = true;
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let states = history.state;
       console.log("recived parametert==>", states);
      //  if(states.pageUpdate){
      //     const currentUrl = this.router.url;
      //     this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      //       this.router.navigate([currentUrl]);
      //     });
      //  }else 
       if(states.selectedProgram == "ABM"){
            if(this.abmYesFlow){
              this.showABMOrgIdPage = true;
              this.disableKME = this.isKMEFanAvailable ? false : true;
              this.disableZTE = this.isZTEFanAvailable ? false : true;
            }else{
              if(this.abmRadioSelected === 'Yes'){
                this.showABMOrgIdPage = true;
                this.disableKME = this.isKMEFanAvailable ? false : true;
                this.disableZTE = this.isZTEFanAvailable ? false : true;
              }else{
                this.continueNext("step3");
              }
              
            }  
        }else if(states.selectedProgram == "KME"){
          this.continueWithKME(states.prevPage);
        }else if(states.selectedProgram == "ZTE"){
          if(this.zteNoFlow){
            this.continueWithZTENo(states.prevPage);
          }else{
            this.continueWithZTEYes(states.prevPage);
          }
          
        }
    });

    this.responseOptionControl = new FormControl(null);
    this.responseOptionControl.valueChanges.subscribe((value) => {
      console.log('Selected option:', value);
      this.abmRadioSelected = value;
      this.zteRadioSelected = value;
      this.kmeRadioSelected = value;
    });

    this.resellerId = this.utilityService.getEnvConfig().abmfeDepResellerId;
    this.zteResellerId = this.utilityService.getEnvConfig().zteResellerId;
    this.kmeResellerId = this.utilityService.getEnvConfig().kmeResellerId;
    console.log("resellerId===>", this.resellerId);
    this.selectService = new FormGroup({
      responseOptionControl: this.responseOptionControl
    });
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.agreementID = this.user.user.agreement.id;
    this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Product selection', routerLink: '/productselection' });
    this.hideTextBox = true;
    this.generalDescription = true;
    this.zteYesStep1 = true;
    // sessionStorage.setItem('feFlag', "false");
    this.previousRoute = sessionStorage.getItem('previousRoute');
    this.reenrollflag = JSON.parse(sessionStorage.getItem('reenrollappleflag'));
    this.setABMdefault = sessionStorage.getItem('ABMApply');
    // if(this.setABMdefault == "true"){
    //   this.selectedRadioApple = true;
    //   this.abmselected = true;
    //   this.abmflag = true;
    //   this.mdmDetails.emmProductCode = this.MdmSelection = "DMPAABM";
    // }
    //this.productSelectionService.getFanStatusSummary().subscribe(responseObject => {
      //check addp_apple_fe permission for CI
      let responseObject = sessionStorage.getItem("accountSummaryData") ? JSON.parse(sessionStorage.getItem("accountSummaryData")): null;
      // this.authenticationService.getUserDetails()
      //   .subscribe((resp) => {
          this.profileAndPermsInfo = JSON.parse(sessionStorage.getItem('profileAndPermsInfo'));
          if(location.href.includes("admin")){
            let firstName = localStorage.getItem('customerFirstName') ? localStorage.getItem('customerFirstName') : this.profileAndPermsInfo.profile.user.firstName;
            let lastName = localStorage.getItem('customerLastName') ? localStorage.getItem('customerLastName') : this.profileAndPermsInfo.profile.user.lastName;
            this.FirstName = firstName;
            this.LastName = lastName;
          }else{
            this.FirstName = this.profileAndPermsInfo.profile.user.firstName;
            this.LastName = this.profileAndPermsInfo.profile.user.lastName;
          }
          
          this.Role = this.profileAndPermsInfo.profile.user.role;
          this.Email = this.profileAndPermsInfo.profile.user.email;
          // console.log("profileAndPermsInfo===>", profileAndPermsInfo);
          if (!this.ABMFECI) {//ABMFEGA flag set in mongodb if false then check CI customer
            console.log("ABMFECI", this.ABMFECI);
            if (this.profileAndPermsInfo.profile) {
              let perms = this.profileAndPermsInfo.profile.permissions;
              if (perms.addp_apple_fe) {
                console.log("ABM FECI: grant");
                if (perms.addp_apple_fe == "GRANT") {
                  //show apply button
                  // this.showABMFEApplyButton(responseObject);
                  this.isABMCI_PermissionGrant = true;
                  this.checkAppleDEP(responseObject);
                } else {
                  //hide apply button
                  this.isABMCI_PermissionGrant = false;
                  this.showABMFEOption = false;
                  sessionStorage.setItem("ABMFE", "false");
                  this.checkAppleDEP(responseObject);
                }
              } else {
                console.log("ABM FECI: deny");
                //show apply button
                // this.showABMFEApplyButton(responseObject);
                this.isABMCI_PermissionGrant = true;
                this.checkAppleDEP(responseObject);
              }
            }
          } else {//ABMFEGA is true means, ABM FE is available for all
            this.isABMCI_PermissionGrant = true;
            this.checkAppleDEP(responseObject);
          }
        // });


      sessionStorage.setItem('fanInfoList', JSON.stringify(responseObject.fanInfoList));
    // })
    if (this.previousRoute === '/home' || this.reenrollflag) {
      sessionStorage.removeItem('signedupData');
      sessionStorage.removeItem('failFromReviewFlag');
      sessionStorage.removeItem('enrollArray');
    } else {
      this.failFromReviewFlag = sessionStorage.getItem('failFromReviewFlag');
    }
    this.fetchData();
  }

  continueWithABM() {
    
    this.uncheckFansAndEnroll();
    // sessionStorage.removeItem('signupFanList');
    sessionStorage.setItem("ABMFE", "false");
    sessionStorage.setItem("feFlag", "false");
    this.abmNoStep3 = false;
    this.abmNoStep4 = false;
    if(this.abmRadioSelected === 'Yes') {
      this.showABMYesContent = true;
      this.hideTextBox = true;
      this.disableZTE = true;
      this.disableKME = true;
      
    }else if(this.abmRadioSelected === 'No'){
      this.isABMFE = true;
      this.disableZTE = true;
      this.disableKME = true;
      // this.showABMNoContent = true;
      this.abmNoStep2 = true;
      this.hideTextBox = true;
      sessionStorage.setItem("ABMFE", "true");
      sessionStorage.setItem("feFlag", "true");
    }else if(this.abmRadioSelected === "I don't know"){
      this.isABMFE = true;
      this.showABMMaybeContent = true;
      this.hideTextBox = true;
      this.disableZTE = true;
      this.disableKME = true;
    }
  }

  goBackToHomePage() {
  this.router.navigate(['/home']);
  }

  backToProductSelectionPage() {
    // this.showABMYesContent = true;
    // this.hideTextBox = false;
    // this.isMobileView = false;
    // this.MdmSelection = "";
    // this.kmeYesStep1 = false;
    // this.kmeNoStep1 = false;
    // this.zteYesStep1 = false;
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  continueToABMOrgId() {
    this.showABMOrgIdPage = true;
    this.showABMYesContent = false;
    this.disableZTE = true;
    this.disableKME = true;
  }

  backToAbmSelectionPage(): void {
    this.showABMYesContent = false; 
    this.hideTextBox = false; 
    this.abmNoStep2 = false;
    this.showABMMaybeContent = false;
    this.disableZTE = this.isZTEFanAvailable ? false : true;
    this.disableKME = this.isKMEFanAvailable ? false : true;
  }

  toggleABMTooltip(event: Event): void {
    event.stopPropagation();
    this.isABMTooltipVisible = !this.isABMTooltipVisible;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    this.isABMTooltipVisible = false;
  }

  copyResellerId(): void {
    if (this.resellerId) {
      navigator.clipboard.writeText(this.resellerId).then(() => {
        this.copiedResellerId = true; // Show the "Copied" message
        setTimeout(() => {
          this.copiedResellerId = false; // Hide the message after 2 seconds
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy Reseller ID: ', err);
      });
    }
  }

  copyZTEResellerId(): void {
    if (this.zteResellerId) {
      navigator.clipboard.writeText(this.zteResellerId).then(() => {
        this.copiedResellerId = true; // Show the "Copied" message
        setTimeout(() => {
          this.copiedResellerId = false; // Hide the message after 2 seconds
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy Reseller ID: ', err);
      });
    }
  }

  copyKMEResellerId(): void {
    if (this.kmeResellerId) {
      navigator.clipboard.writeText(this.kmeResellerId).then(() => {
        this.copiedResellerId = true; // Show the "Copied" message
        setTimeout(() => {
          this.copiedResellerId = false; // Hide the message after 2 seconds
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy Reseller ID: ', err);
      });
    }
  }

  backToCopyResellerPage() {
    if(this.showBackButton){
      this.showABMYesContent = true;
      this.showABMOrgIdPage = false;
    }else{
      this.backToProductSelectionPage();
    }
    
  }

  checkAppleDEP(responseObject) {
    let promises = [];
    this.pageloaderService.setPageLoaderStatus(false);
    let allFans = this.profileAndPermsInfo.fans;
    let fanConcat = allFans.join("A");
    let mapData = new Map();
    // allFans.forEach((elm) => {
    //   let data = new Promise((resolve, reject) => {
        //let fan_ = this.romeCallFailed ? elm + "s" : elm;//mock check for romecall failed
        this.productSelectionService.getInquireProfile(fanConcat).subscribe((resp: any) => {
          if(resp){
            this.appleDEPFANs = resp.appleDepTrue;
            let appleDepTrue = resp.appleDepTrue.length > 0 ? resp.appleDepTrue.forEach((elm) => {mapData.set(elm, true);}) : [];
            // let appleDepFalse = resp.appleDepFalse.forEach((elm) => {mapData.set(elm, false);});
            console.log("mapData===>", mapData.entries());
            console.log("appleDepTrue==>", appleDepTrue);
            sessionStorage.setItem("mapAppleDep", JSON.stringify(Array.from(mapData.entries())));
            this.pageloaderService.setPageLoaderStatus(true);
            if (resp.appleDepTrue.length > 0) {
              this.showABMFEOption = false;
              this.abmYesFlow = true;
              this.showABMOrgIdPageFunc(true);
              this.showABMFEApplyButton(responseObject);
              sessionStorage.setItem("ABMFE", "false");
            } else {
              // this.showABMFEOption = true;
              // sessionStorage.setItem("ABMFE", "true");
              this.abmYesFlow = false;
              this.showABMFEApplyButton(responseObject);
            }
            this.disableTiles();
          }else{
            this.showABMFEOption = false;
            this.abmYesFlow = true;
            this.showABMOrgIdPageFunc(true);
            sessionStorage.setItem("ABMFE", "false");
            this.disableTiles();
          }

        }, (error) => {
          this.pageloaderService.setPageLoaderStatus(true);
          // this.showABMFEOption = true;
          // sessionStorage.setItem("ABMFE", "true");
          this.showABMFEApplyButton(responseObject);
          this.appleDEPCallFailed = true;
          this.showErrors = true;
          this.disableTiles();
        })
      // });

    //   promises.push(data);
    // });

    // Promise.all(promises)
    //   .then((response) => {
    //     this.appleDEPCallFailed = false;
    //     this.showErrors = false;
    //     console.log("mapData.entries()", mapData);
    //     sessionStorage.setItem("mapAppleDep", JSON.stringify(Array.from(mapData.entries())));
    //     console.log("All fans response: ", response);
    //     this.pageloaderService.setPageLoaderStatus(true);
    //     if (response.indexOf(1) != -1) {
    //       this.showABMFEOption = false;
    //       sessionStorage.setItem("ABMFE", "false");
    //     } else {
    //       // this.showABMFEOption = true;
    //       // sessionStorage.setItem("ABMFE", "true");
    //       this.showABMFEApplyButton(responseObject);
    //     }
    //   })
    //   .catch((e) => {
    //     // handle errors here
    //     this.pageloaderService.setPageLoaderStatus(true);
    //     console.log("promise error: ", e);
    //     // this.showABMFEOption = true;
    //     // sessionStorage.setItem("ABMFE", "true");
    //     this.showABMFEApplyButton(responseObject);
    //     this.appleDEPCallFailed = true;
    //     this.showErrors = true;
    //   });

  }

  showABMFEApplyButton(responseObject) {
    let abmCount = 0;
    let abmID = '';
    // if (this.isABMCI_PermissionGrant) {
      if (responseObject.fanInfoList) {
        responseObject.fanInfoList.forEach((elm: any) => {
          if (elm.emmProductCode == "DMPAABM") {
            if((elm.accountStatus == "SIGNUP_INPROGRESS") ||
            (elm.accountStatus == "REMOVE_INPROGRESS") ||
             (elm.accountStatus == "PROCESSING" && elm.emmAccountId) || 
             (elm.accountStatus == "ACTIVE" && elm.emmAccountId) || 
             (elm.accountStatus == "INACTIVE" && elm.emmAccountId)){
                // console.log("elm.emmProductCode===>", elm.emmProductCode);
                abmID = elm.emmAccountId;
              abmCount++;
            }
          }
        });
        console.log("abmCount==>", abmCount);
        if (abmCount > 0 && !this.isAdminPortal) {
          this.appleValue = abmID;
          this.showABMFEOption = false;
          this.abmYesFlow = true;
          this.showABMOrgIdPageFunc(true);
          sessionStorage.setItem("ABMFE", "false");
        }
        else if(this.appleDEPFANs && this.appleDEPFANs.length > 0){
          this.showABMFEOption = false;
          this.abmYesFlow = true;
          this.showABMOrgIdPageFunc(true);
          sessionStorage.setItem("ABMFE", "false");
        } else {
          this.abmYesFlow = this.abmYesFlow;
          this.showABMFEOption = true;
          sessionStorage.setItem("ABMFE", "true");
        }
      } else {
        this.showABMFEOption = true;
        sessionStorage.setItem("ABMFE", "true");
      }
    // } else {
    //   this.showABMFEOption = false;
    //   this.abmYesFlow = true;
    //   this.showABMOrgIdPageFunc(true);
    //   sessionStorage.setItem("ABMFE", "false");
    // }
  }

  selectedABMOption(event: Event) {
    console.log('Selected Option:', this.responseOptionControl.value);
  }



  fetchData() {
    sessionStorage.removeItem('savedSelectedDetails');
    sessionStorage.removeItem('manage-product');
    sessionStorage.removeItem('selectedSignupFanList');
    //sessionStorage.removeItem('enrollArray');
    sessionStorage.removeItem('fanDetails');
    sessionStorage.removeItem('backFromReview');
    sessionStorage.removeItem('step1done');
    if (this.failFromReviewFlag === 'false') {
      sessionStorage.removeItem('signedupData');
      sessionStorage.removeItem('enrollArray');
    } else if (this.failFromReviewFlag === 'true' || this.reenrollflag) {
      this.selectedValuesSession = null;
    }

    this.selectedProd = sessionStorage.getItem('selectedProd');
    this.sessionData = JSON.parse(sessionStorage.getItem('mdmDetails'));
    this.productSelectionModel = this.route.snapshot.data.pageData.productselection;
    this.productSelection = this.route.snapshot.data.pageData.productselection;
    this.isDataAvailable = true;
    this.staticTcUrl = this.productSelection.termsAndConditionsURL;
    this.abmOrgIdValidationError = this.productSelection.orgIdValidationError;
    this.checkTransactionMock = this.productSelection.checkTransactionMock;
    this.abmOrgIdValidationTimeOutError = this.productSelection.orgIdValidationTimeoutError;
    this.ABMFECI = this.productSelection.ABMFEGA;
    this.romeCallFailed = false;//this.productSelection.romeCallFailed; //for test only - mock check romecall failed
    this.buildForm();
    this.signUpStatus = '';
    const permission = JSON.parse(sessionStorage.getItem('permissions')).perm;
    this.abmflag = this.utilityService.checkComponentShowPermission("apple.productselection", permission);
    this.abmFeFlag = this.utilityService.checkComponentShowPermission("appleFE.productselection", permission);
    this.IFDMock = this.productSelection.IFDMock
    if (this.isDataAvailable) {
      this.isDataAvailable = false;
      if (this.selectedValuesSession === null && this.sessionMdmDetails === null) {
        this.initialProductSelectionDetails();

      } else if (this.selectedValuesSession !== null && this.sessionMdmDetails) {
        if (this.selectedValuesSession.enteredGoogleValue === '' || this.selectedValuesSession.enteredSamsungValue === '' || this.selectedValuesSession.enteredAppleValue === '') {
          this.preSelectProductDetails();
        }
      } else if (this.selectedValuesSession === null && this.sessionMdmDetails) {
        this.preSelectProductDetails();
      } else {
        this.checkPermission('google');
        this.checkPermission('samsung');
        this.checkPermission('apple');
        this.signupEmmStatus = 'initial';
        if (this.selectedValuesSession.enteredGoogleValue !== null && this.selectedValuesSession.enteredGoogleValue !== '') {
          this.selectedDetails = this.selectedValuesSession.enteredGoogleValue;
        }
        if (this.selectedValuesSession.enteredSamsungValue !== null && this.selectedValuesSession.enteredSamsungValue !== '') {
          this.selectedDetailsKme = this.selectedValuesSession.enteredSamsungValue;
        }
        if (this.selectedValuesSession.enteredAppleValue !== null && this.selectedValuesSession.enteredAppleValue !== '') {
          this.selectedDetailsAbm = this.selectedValuesSession.enteredAppleValue;
        }
      }

      if (this.sessionMdmDetails.samsungEmmAccountId) {
        this.callSamsung = false;
      }
    }
  }

  ngAfterViewInit() {
    this.flagToRemoveCache = JSON.parse(sessionStorage.getItem('cacheFlag'));
    if (this.flagToRemoveCache) {
      sessionStorage.removeItem('cacheFlag');
      this.fetchData();
    }

    

  }


  initialProductSelectionDetails() {
    // if (this.selectedProd === 'samsungknoxmobile') {
    //   this.selectedRadioSamsung = true;
    //   this.kmeselected = true;
    //   this.mdmDetails.emmProductCode = this.MdmSelection = "DMPSKME";
    // } else if (this.selectedProd === 'androidzerotouch') {
    //   this.selectedRadioGoogle = true;
    //   this.ztpselected = true;
    //   this.mdmDetails.emmProductCode = this.MdmSelection = "DMPGZTP";
    // } else if (this.selectedProd === 'applebusinessmanager' || this.failFromReviewFlag === 'true' || this.reenrollflag) {
    //   this.selectedRadioApple = true;
    //   this.abmselected = true;
    //   this.mdmDetails.emmProductCode = this.MdmSelection = "DMPAABM";
    // } else {
    //   this.mdmDetails.emmProductCode = '';
    //   this.preSelectedMdmselect = '';
    // }
    this.mdmDetails.emmProductCode = '';
    this.preSelectedMdmselect = '';
    //this.mdmDetails.emmProductCode = '';
    this.mdmDetails.signupStatus = 'initial';
    this.mdmDetails.emmAccountId = '';
    this.mdmDetails.otherProducts[0] = { 'emmProductCode': '', 'signupStatus': '', 'emmAccountId': '' };
    this.mdmDetails.otherProducts[1] = { 'emmProductCode': '', 'signupStatus': '', 'emmAccountId': '' };
    this.userDetail = this.mdmDetails;
    this.setupError = false;
    this.signupEmmStatus = 'initial';
    //this.preSelectedMdmselect = '';
    this.productSelectionStatus = '';
    this.preSelectedMdmDetail = this.preSelectedMdmselect;
    this.productSignupStatus = this.productSelectionStatus;
    this.parentemmAccountId = '';
    this.otherProductsSelection = '';
    this.childemmAccountId[0] = '';
    this.childemmAccountId[1] = '';
    this.checkPermission('google');
    this.checkPermission('samsung');
    this.checkPermission('apple');
    sessionStorage.removeItem('selectedProd');
  }

  preSelectProductDetails() {
    this.sessionData = JSON.parse(sessionStorage.getItem('mdmDetails'));
    if (this.sessionData && this.sessionData.productCode === 'ADDPZTE') {
      this.reenrollflag = JSON.parse(sessionStorage.getItem('reenrollappleflag'));
      if (this.reenrollflag || this.failFromReviewFlag === 'true') {
        this.sessionData.latestAccountType = this.sessionData.emmProductCode = 'DMPAABM';
        this.sessionData.appleEmmAccountId = "";
        //sessionStorage.removeItem('signedupData');
        if (this.failFromReviewFlag === 'false') {
          sessionStorage.removeItem('signedupData');
          sessionStorage.removeItem('enrollArray');
        }
      }

      //kme, ztp & abm
      if (this.sessionData.samsungEmmAccountId && this.sessionData.googleEmmAccountId && this.sessionData.appleEmmAccountId && !this.failFromReviewFlag) {
        this.callSamsung = false;
        if (this.sessionData.latestAccountType === 'DMPGZTP') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPGZTP';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else if (this.sessionData.latestAccountType === 'DMPSKME') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPSKME';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPAABM';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.setupError = false;
        }
      }
      //kme & ztp
      else if (this.sessionData.samsungEmmAccountId && this.sessionData.googleEmmAccountId && !this.failFromReviewFlag) {
        if (this.sessionData.latestAccountType === 'DMPGZTP') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPGZTP';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else if (this.sessionData.latestAccountType === 'DMPSKME') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPSKME';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPAABM';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.setupError = false;
        }
      }
      //ztp & abm
      else if (this.sessionData.appleEmmAccountId && this.sessionData.googleEmmAccountId && !this.failFromReviewFlag) {
        if (this.sessionData.latestAccountType === 'DMPGZTP') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPGZTP';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else if (this.sessionData.latestAccountType === 'DMPSKME') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPSKME';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPAABM';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.setupError = false;
        }
      }
      //kme & abm
      else if (this.sessionData.appleEmmAccountId && this.sessionData.samsungEmmAccountId && !this.failFromReviewFlag) {
        if (this.sessionData.latestAccountType === 'DMPGZTP') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPGZTP';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else if (this.sessionData.latestAccountType === 'DMPSKME') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPSKME';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPAABM';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.setupError = false;
        }
      }
      //kme only
      else if (this.sessionData.samsungEmmAccountId && !this.failFromReviewFlag) {
        this.callSamsung = false;
        // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPSKME';
        // this.mdmDetails.signupStatus = 'revised';
        // this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
        // this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPGZTP' , 'signupStatus' : 'initial' , 'emmAccountId' : ''};
        // this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPAABM', 'signupStatus' : 'initial' , 'emmAccountId' :  ''};
        if (this.sessionData.latestAccountType === 'DMPGZTP') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPGZTP';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else if (this.sessionData.latestAccountType === 'DMPSKME') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPSKME';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPAABM';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.setupError = false;
        }
      }
      //ztp only
      else if (this.sessionData.googleEmmAccountId && !this.failFromReviewFlag) {
        // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPGZTP';
        // this.mdmDetails.signupStatus = 'revised';
        // this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
        // this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPSKME' , 'signupStatus' : 'initial' , 'emmAccountId' : ''};
        // this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPAABM', 'signupStatus' : 'initial' , 'emmAccountId' :  ''};
        if (this.sessionData.latestAccountType === 'DMPGZTP') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPGZTP';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else if (this.sessionData.latestAccountType === 'DMPSKME') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPSKME';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPAABM';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.setupError = false;
        }
      }
      //abm only
      else {
        // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPAABM';
        // this.mdmDetails.signupStatus = 'revised';
        // this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
        // this.mdmDetails.otherProducts[0] = {'emmProductCode' : 'DMPSKME' , 'signupStatus' : 'initial' , 'emmAccountId' : ''};
        // this.mdmDetails.otherProducts[1] = {'emmProductCode' : 'DMPGZTP', 'signupStatus' : 'initial' , 'emmAccountId' :  ''};
        // this.setupError = false;
        if (this.sessionData.latestAccountType === 'DMPGZTP') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPGZTP';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.googleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else if (this.sessionData.latestAccountType === 'DMPSKME') {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPSKME';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.samsungEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPAABM', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.appleEmmAccountId };
        } else {
          // this.mdmDetails.emmProductCode = this.MdmSelection = 'DMPAABM';
          this.mdmDetails.signupStatus = 'revised';
          // this.mdmDetails.emmAccountId = this.sessionData.appleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.googleEmmAccountId };
          this.mdmDetails.otherProducts[1] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 'emmAccountId': this.sessionData.samsungEmmAccountId };
          this.setupError = false;
        }
      }
    }
    else {
      this.mdmDetails.emmProductCode = '';
      this.mdmDetails.signupStatus = 'initial';
      this.mdmDetails.emmAccountId = '';
      this.mdmDetails.otherProducts[0] = { 'emmProductCode': '', 'signupStatus': '', 'emmAccountId': '' };
      this.mdmDetails.otherProducts[1] = { 'emmProductCode': '', 'signupStatus': '', 'emmAccountId': '' };
    }

    this.userDetail = this.mdmDetails;

    if (this.userDetail) {

      //for default selection when redirected from prod page
      if (this.selectedProd === 'samsungknoxmobile') {
        this.selectedRadioSamsung = true;
        this.kmeselected = true;
        this.userDetail.emmProductCode = this.MdmSelection = "DMPSKME";
        this.preSelectedMdmselect = this.userDetail.emmProductCode;
        this.preSelectedMdmDetail = this.preSelectedMdmselect;
        this.parentemmAccountId = this.userDetail.emmAccountId = this.sessionData.samsungEmmAccountId;
      } else if (this.selectedProd === 'androidzerotouch') {
        this.selectedRadioGoogle = true;
        this.ztpselected = true;
        this.userDetail.emmProductCode = this.MdmSelection = "DMPGZTP";
        this.preSelectedMdmselect = this.userDetail.emmProductCode;
        this.preSelectedMdmDetail = this.preSelectedMdmselect;
        this.parentemmAccountId = this.userDetail.emmAccountId = this.sessionData.googleEmmAccountId;
      } else if (this.selectedProd === 'applebusinessmanager') {
        this.selectedRadioApple = true;
        this.abmselected = true;
        this.userDetail.emmProductCode = this.MdmSelection = "DMPAABM";
        this.preSelectedMdmselect = this.userDetail.emmProductCode;
        this.preSelectedMdmDetail = this.preSelectedMdmselect;
        this.parentemmAccountId = this.userDetail.emmAccountId = "";
        this.setupError = false;
        //sessionStorage.setItem('selectNow', 'true');
      } else {
        this.preSelectedMdmselect = this.userDetail.emmProductCode;
        this.preSelectedMdmDetail = this.preSelectedMdmselect;
        this.parentemmAccountId = this.userDetail.emmAccountId;
      }
      this.productSelectionStatus = this.userDetail.signupStatus;
      // this.preSelectedMdmselect = this.userDetail.emmProductCode;
      // this.preSelectedMdmDetail = this.preSelectedMdmselect;
      // this.parentemmAccountId = this.userDetail.emmAccountId;
      this.productSignupStatus = this.productSelectionStatus;
      this.checkPermission('google');
      this.checkPermission('samsung');
      this.checkPermission('apple');

      if (this.userDetail.otherProducts.length === 0) {
        this.otherProductsSelection = '';
        this.childemmAccountId[0] = [];
        this.childemmAccountId[1] = [];
      } else {
        this.otherProductsSelection = this.userDetail.otherProducts[0].signupStatus;
        this.childemmAccountId[0] = this.userDetail.otherProducts[0].emmAccountId;
        this.childemmAccountId[1] = this.userDetail.otherProducts[1].emmAccountId;
      }
      if (this.userDetail.emmProductCode === 'DMPGZTP' && this.userDetail.signupStatus === 'revised') {
        this.selectedRadioGoogle = true;
        this.ztpselected = true;
        this.productSelectionService.setProdCode('ZTP');
        this.parentemmAccountId = this.userDetail.emmAccountId;
        this.selectedDetails = this.parentemmAccountId;
        this.signupEmmStatus = 'revised';
        if (this.parentemmAccountId !== null) {
          this.setupError = false;
        }
        if (this.otherProductsSelection === 'revised') {
          this.selectedDetailsKme = this.childemmAccountId[0];
          this.selectedDetailsAbm = this.childemmAccountId[1];
        }

      } else if (this.userDetail.emmProductCode === 'DMPSKME' && this.userDetail.signupStatus === 'revised') {
        this.selectedRadioSamsung = true;
        this.kmeselected = true;
        this.productSelectionService.setProdCode('KME');
        this.parentemmAccountId = this.userDetail.emmAccountId;
        this.selectedDetailsKme = this.parentemmAccountId;
        this.signupEmmStatus = 'revised';
        if (this.parentemmAccountId !== null) {
          this.setupError = false;
        }
        if (this.otherProductsSelection === 'revised') {
          this.selectedDetails = this.childemmAccountId[0];
          this.selectedDetailsAbm = this.childemmAccountId[1];
        }
      } else if (this.userDetail.emmProductCode === 'DMPAABM' && this.userDetail.signupStatus === 'revised') {
        this.selectedRadioApple = true;
        this.abmselected = true;
        this.productSelectionService.setProdCode('ABM');
        this.parentemmAccountId = this.userDetail.emmAccountId;
        this.selectedDetailsAbm = this.parentemmAccountId;
        this.signupEmmStatus = 'revised';
        if (this.parentemmAccountId !== null) {
          this.setupError = false;
        }
        if (this.otherProductsSelection === 'revised') {
          this.selectedDetails = this.childemmAccountId[0];
          this.selectedDetailsKme = this.childemmAccountId[1];

        }
      }
    }
    sessionStorage.removeItem('selectedProd');
  }

  buildForm(): void {

    this.selectService = this.formBuilder.group({
      'googleIdName': ['', [Validators.required, Validators.
        pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      'googleIdNameConfirm': ['', [Validators.required, Validators.
        pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      'googleIdZteName': ['', [Validators.required, Validators.pattern(/(^[0-9]{5,50}$)+$/)]],
      'googleIdNameZteConfirm': ['', [Validators.required, Validators.pattern(/(^[0-9]{5,50}$)+$/)]],
      'samsungIdName': ['', [Validators.required, Validators.pattern(/(^[0-9]{8,20}$)+$/)]],
      'appleIdName': ['', [Validators.required, Validators.pattern(/^[0-9A-Za-z]{1,32}$/)]],
      'appleIdName1': ['', [Validators.required, Validators.pattern(/^[0-9A-Za-z]{1,32}$/)]],
      'MdmSelection': ['', [Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]]
    },
      { validators: this.validateAreEqual },
    );
    this.validationService.validate(
      this.selectService,
      this.formErrors,
      this.validationMessages
    );
  }

  public validateAreEqual(c: AbstractControl): { notSame: boolean } | null {
    if (c.value.googleIdZteName && c.value.googleIdNameZteConfirm) {
      return c.value.googleIdZteName === c.value.googleIdNameZteConfirm ? null : { notSame: true };
    } else {
      return c.value.googleIdName === c.value.googleIdNameConfirm ? null : { notSame: true };
    }
  }


  /*check mobile view for support article accordion*/
  mobileView() {
    this.helpArticles = [{ id: 1, isActive: !this.isMobile, category: 'Help', content: '' }];
  }


  checkPermission(field) {
    const permission = JSON.parse(sessionStorage.getItem('permissions'));
    if (permission !== 'null') {
      if (!this.utilityService.checkComponentPermission(field, permission.perm)) {
        if (field === 'samsung') {
          this.isSamsungDisable = true;
        } else if (field === 'google') {
          this.isGoogleDisable = true;
        } else {
          this.isAppleDisable = true;
        }
      }
    }
  }


  onChangeText() {
    this.setupError = false;
    this.setupZteError = false;
    event = Object(event);
    if ((this.googleValue === '' || this.googleValue === null || this.googleValue === undefined) && (this.googleIdValue === '' || this.googleIdValue === null || this.googleIdValue === undefined)) {
      //this.setupError = true;
      this.isDisable = true;
    } else if (this.googleValue || this.googleIdValue) {
      this.setupError = false;
      this.errorMessage = false;
      this.isDisable = false;
    } else if (this.selectedValuesSession !== null) {
      if (this.selectedValuesSession.enteredGoogleValue) {
        if (this.showGoogleCreationError === true || this.selectedValuesSession.enteredGoogleValue === this.googleValue) {
          this.errorMessage = 'We were unable to complete your request. Please check that you' +
            ' have entered a valid email address or Google ID.';
          this.pageloaderService.setPageLoaderStatus(true);
          this.utilityService.loadFocusOnTop();
        }
      } else if (this.selectedValuesSession.enteredGoogleValue !== this.googleValue) {
        //this.signupEmmStatus = 'initial';
        this.selectedValuesSession.enteredGoogleValue = this.googleValue;
        this.setupError = false;
        this.errorMessage = false;
        this.isDisable = false;
      }
    }
  }

  onChangeTextNum() {
    this.setupError = false;
    event = Object(event);
    if (this.samsungValue === '' || this.samsungValue === null || this.samsungValue === undefined) {
      //this.setupError = true;
      this.isDisable = true;
    } else if (this.samsungValue) {
      this.setupError = false;
      this.errorMessage = false;
      this.isDisable = false;
    } else if (this.selectedValuesSession !== null) {
      //this.signupEmmStatus = 'initial';
      this.selectedValuesSession.enteredSamsungValue = this.samsungValue;
      this.setupError = false;
      this.errorMessage = false;
      this.isDisable = false;
    }
  }

  onChangeOrg(event) {
    this.setupError = false;
    event = Object(event);
    if (this.appleValue === '' || this.appleValue === null || this.appleValue === undefined || this.appleValue1 === '' || this.appleValue1 === null || this.appleValue1 === undefined) {
      this.isDisable = true;
    } else if (this.appleValue !== this.appleValue1) {
      this.isDisable = true;
    } else if (this.selectedValuesSession !== null) {
      //this.signupEmmStatus = 'initial';
      this.selectedValuesSession.enteredAppleValue = this.appleValue;
      this.setupError = false;
      this.errorMessage = false;
      this.isDisable = false;
    } else if (this.appleValue && this.appleValue1) {
      this.setupError = false;
      this.errorMessage = false;
      this.isDisable = false;
    }
  }

  keyValidation(event) {
    event = Object(event);
    if (event) {
      this.setupError = false;
      this.isDisable = false;
    } else {
      this.setupError = true;
    }
  }

  onlyNumberKey(event) {
    event = Object(event);
    if (event) {
      if (event.code === 'Digit' + event.key) {
        this.setupError = false;
        this.isDisable = false;
        sessionStorage.removeItem('selectNow');
      }
    } else {
      this.setupError = true;
    }
  }

  prodSelectedztp($event) {
    if(!this.disableZTE){
    if ($event.target.value = 'on') {
      this.setupError = false;
      //this.notequalError = false;
      this.responseOptionControl.reset();
      this.productSelectionService.setProdCode('ZTP');
      this.MdmSelection = 'DMPGZTP';
      sessionStorage.setItem('product-selected', this.MdmSelection);
      this.selectedRadioGoogle = true;
      this.isDisable = true;
      this.selected = true;
      this.ztpselected = true;
      this.abmselected = false;
      this.kmeselected = false;
      this.generalDescription = false;
      if (this.sessionData.googleEmmAccountId) {
        this.selectedDetails = this.sessionData.googleEmmAccountId;
        this.isDisable = false;
      } else if (this.sessionData === null) {
        this.isDisable = true;
      } else if (this.sessionData.googleEmmAccountId === undefined) {
        this.isDisable = true;
      }
    }
  }
  }

  prodSelectedabm($event) {
    if(!this.disableABM){
    if ($event.target.value = 'on') {
      this.setupError = false;
      this.responseOptionControl.reset();
      //this.notequalError = false;
      this.productSelectionService.setProdCode('ABM');
      this.MdmSelection = 'DMPAABM';
      sessionStorage.setItem('product-selected', this.MdmSelection);
      this.selectedRadioApple = true;
      this.isDisable = true;
      this.selected = true;
      //sessionStorage.setItem('selectNow', 'true');
      this.ztpselected = false;
      this.abmselected = true;
      this.kmeselected = false;
      this.generalDescription = false;
      this.hideTextBox = false;
      this.showABMOrgIdPageFunc(this.abmYesFlow);
    }
  }
  }

  prodSelectedkme($event) {
    if(!this.disableKME){
    if ($event.target.value = 'on') {
      this.setupError = false;
      this.responseOptionControl.reset();
      //this.notequalError = false;
      this.productSelectionService.setProdCode('KME');
      this.MdmSelection = 'DMPSKME';
      sessionStorage.setItem('product-selected', this.MdmSelection);
      this.selectedRadioSamsung = true;
      this.isDisable = true;
      this.selected = true;
      this.ztpselected = false;
      this.abmselected = false;
      this.kmeselected = true;
      this.generalDescription = false;
      this.kmeYesStep1 = true;
      if (this.sessionData.samsungEmmAccountId) {
        this.selectedDetailsKme = this.sessionData.samsungEmmAccountId;
        this.isDisable = false;
      } else if (this.sessionData === null) {
        this.isDisable = true;
      } else if (this.sessionData.samsungEmmAccountId === undefined) {
        this.isDisable = true;
      }
    }
  }
  }

  cancel() {
    this.router.navigate(['/dashboard']);
  }

  toggleTooltip(event) {
    if (event.type !== 'click') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipEnter(event) {
    if (event.type !== 'mouseenter') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipLeave(event) {
    if (event.type !== 'mouseleave') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  onTooltipIconEnter(event: MouseEvent | KeyboardEvent) {
    clearTimeout(this.tooltipTimeout);
    if (
      (event instanceof MouseEvent && event.type === 'mouseenter') ||
      (event instanceof KeyboardEvent && event.key === 'Enter')
    ) {
      const target = event.target as HTMLElement;
      this.showTooltip(target);
    }
  }
   
  onTooltipIconLeave(event: MouseEvent | KeyboardEvent) {
    this.tooltipTimeout = setTimeout(() => {
      if (
        (event instanceof MouseEvent && event.type === 'mouseleave') ||
        (event instanceof KeyboardEvent && event.key === 'Enter')
      ) {
        this.hideTooltip();
      }
    }, 150);
  }
   
  onTooltipContentEnter() {
    clearTimeout(this.tooltipTimeout);
  }
   
  onTooltipContentLeave() {
    this.tooltipTimeout = setTimeout(() => {
      this.hideTooltip();
    }, 150);
  }
   
  showTooltip(target: HTMLElement) {
    document.querySelectorAll('.tooltipActive').forEach(ele => {
      ele.classList.remove('tooltipActive');
    });
   
    target.classList.add('tooltipActive');
    this.activeTooltipElement = target;
    this.isTooltipVisible = true;
  }
   
  hideTooltip() {
    document.querySelectorAll('.tooltipActive').forEach(ele => {
      ele.classList.remove('tooltipActive');
    });
    this.activeTooltipElement = null;
    this.isTooltipVisible = false;
  }
   
  onTooltipKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === ESCAPE_KEY) {
      this.hideTooltip();
    }
  }
   
  @HostListener('document:keydown', ['$event'])
  handleGlobalEscape(event: KeyboardEvent) {
    if (this.isTooltipVisible &&
      (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27)
    ) {
      this.onTooltipKeydown(event);
    }
  }


  signupSetupSubmit(event: any) {
    this.isABMFE = false;
    this.setupError = false;
    //this.notequalError = false;
    this.pageloaderService.setPageLoaderStatus(false);
    sessionStorage.removeItem('reenrollappleflag');
    //if new value entered
    if (this.selectService.dirty) {
      this.productSelectionModel.googleIdName = this.selectService.value.googleIdName;
      this.productSelectionModel.googleIdNameConfirm = this.selectService.value.googleIdNameConfirm;
      this.productSelectionModel.googleIdZteName = this.selectService.value.googleIdZteName;
      this.productSelectionModel.googleIdNameZteConfirm = this.selectService.value.googleIdNameZteConfirm;
      this.productSelectionModel.samsungIdName = this.selectService.value.samsungIdName;
      this.productSelectionModel.appleIdName = this.selectService.value.appleIdName;
      this.productSelectionModel.MdmSelection = this.MdmSelection;//this.selectService.value.MdmSelection;
      if (this.productSelectionModel.MdmSelection === 'DMPAABM') {
        this.selectedAccID = this.productSelectionModel.appleIdName;
      } else if (this.productSelectionModel.MdmSelection === 'DMPGZTP') {
        this.selectedAccID = this.productSelectionModel.googleIdName;
      } else {
        this.selectedAccID = this.productSelectionModel.samsungIdName;
      }
    } else {
      //if existing value and re-selected
      if (this.selectService.value.MdmSelection) {
        if (this.selectService.value.MdmSelection === 'DMPGZTP') {
          this.productSelectionModel.MdmSelection = 'DMPGZTP';
          this.selectedAccID = this.selectedDetails;
        } else if (this.selectService.value.MdmSelection === 'DMPSKME') {
          this.callSamsung = true;
          this.productSelectionModel.MdmSelection = 'DMPSKME';
          this.selectedAccID = this.selectedDetailsKme;
        } else {
          this.callApple = true;
          this.productSelectionModel.MdmSelection = 'DMPAABM';
          this.selectedAccID = this.selectedDetailsAbm ? this.selectedDetailsAbm : this.appleValue;//this.selectedDetailsAbm;
        }
      } else {
        //if existing value and preselected
        if (this.preSelectedMdmDetail === 'DMPGZTP') {
          this.productSelectionModel.MdmSelection = this.preSelectedMdmDetail;
          this.selectedAccID = this.selectedDetails;
        } else if (this.preSelectedMdmDetail === 'DMPSKME') {
          this.callSamsung = true;
          this.productSelectionModel.MdmSelection = this.preSelectedMdmDetail;
          this.selectedAccID = this.selectedDetailsKme;
        } else {
          this.callApple = true;
          this.productSelectionModel.MdmSelection = 'DMPAABM';
          this.selectedAccID = this.selectedDetailsAbm ? this.selectedDetailsAbm : this.appleValue;
        }
      }

    }
    this.selectedMdmDetails = this.productSelectionModel.MdmSelection;

    let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
    productDetails.emmProductCode = this.selectedMdmDetails;
    productDetails.selectedAccID = this.selectedAccID;
    productDetails.signupEmmStatus = this.signupEmmStatus;
    if (this.selectedValuesSession != null) {
      //need more clarity n input for the conditioning

      //normal combinations
      if (this.selectedValuesSession.preSelectedEmm === '' && this.selectedMdmDetails === 'DMPGZTP') {
        productDetails.signupEmmStatus = 'initial';
      }
      if (this.selectedValuesSession.preSelectedEmm === 'DMPGZTP' && this.selectedMdmDetails === 'DMPGZTP') {
        productDetails.signupEmmStatus = 'revised';
      }
      if (this.selectedValuesSession.preSelectedEmm === '' && this.selectedMdmDetails === 'DMPSKME') {
        productDetails.signupEmmStatus = 'initial';
      }
      if (this.selectedValuesSession.preSelectedEmm === 'DMPSKME' && this.selectedMdmDetails === 'DMPSKME') {
        productDetails.signupEmmStatus = 'revised';
      }
      if (this.selectedValuesSession.preSelectedEmm === '' && this.selectedMdmDetails === 'DMPAABM') {
        productDetails.signupEmmStatus = 'initial';
      }
      if (this.selectedValuesSession.preSelectedEmm === 'DMPAABM' && this.selectedMdmDetails === 'DMPAABM') {
        productDetails.signupEmmStatus = 'revised';
      }
      //double comparison combinations
      //g&s-s&g
      if (this.selectedValuesSession.preSelectedEmm === 'DMPGZTP' && this.selectedMdmDetails === 'DMPSKME' &&
        this.selectedValuesSession.childStatus === 'initial') {
        productDetails.signupEmmStatus = 'initial';
      }
      if (this.selectedValuesSession.preSelectedEmm === 'DMPSKME' && this.selectedMdmDetails === 'DMPGZTP' &&
        this.selectedValuesSession.childStatus === 'initial') {
        productDetails.signupEmmStatus = 'initial';
      }
      //g&a-a&g
      if (this.selectedValuesSession.preSelectedEmm === 'DMPGZTP' && this.selectedMdmDetails === 'DMPAABM' &&
        this.selectedValuesSession.childStatus === 'initial') {
        productDetails.signupEmmStatus = 'initial';
      }
      if (this.selectedValuesSession.preSelectedEmm === 'DMPAABM' && this.selectedMdmDetails === 'DMPGZTP' &&
        this.selectedValuesSession.childStatus === 'initial') {
        productDetails.signupEmmStatus = 'initial';
      }
      //s&a-a&s
      if (this.selectedValuesSession.preSelectedEmm === 'DMPSKME' && this.selectedMdmDetails === 'DMPAABM' &&
        this.selectedValuesSession.childStatus === 'initial') {
        productDetails.signupEmmStatus = 'initial';
      }
      if (this.selectedValuesSession.preSelectedEmm === 'DMPAABM' && this.selectedMdmDetails === 'DMPSKME' &&
        this.selectedValuesSession.childStatus === 'initial') {
        productDetails.signupEmmStatus = 'initial';
      }

    } else {
      productDetails.signupEmmStatus = this.signupEmmStatus;
    }
    sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
    let selectedValue = { enteredGoogleValue: '', enteredSamsungValue: '', enteredAppleValue: '' };
    if (this.signupEmmStatus === 'initial' && this.selectedMdmDetails === 'DMPGZTP') {
      selectedValue.enteredGoogleValue = this.productSelectionModel.googleIdName;
    }
    if (this.signupEmmStatus === 'initial' && this.selectedMdmDetails === 'DMPSKME') {
      selectedValue.enteredSamsungValue = this.productSelectionModel.samsungIdName;
    }
    if (this.signupEmmStatus === 'initial' && this.selectedMdmDetails === 'DMPAABM') {
      selectedValue.enteredAppleValue = this.productSelectionModel.appleIdName;
    }
    sessionStorage.setItem('savedSelectedDetails', JSON.stringify(selectedValue));

    sessionStorage.removeItem('showGoogleCreationError');
    let selectedEmmProductCode = sessionStorage.getItem('manage-product');
    this.emmProductCode = JSON.parse(selectedEmmProductCode).emmProductCode;
    //samsung
    if (this.selectedMdmDetails === 'DMPSKME' && !this.isSamsungDisable) {
      sessionStorage.setItem('feFlag', "false");
      if (this.callSamsung) {
        this.productSelectionService.setProdCode('KME');
        sessionStorage.removeItem('signedupData');
        sessionStorage.removeItem('failFromReviewFlag');
        sessionStorage.removeItem('enrollArray');
        this.productSelectionService.signupDetails(this.emmProductCode, this.selectedAccID)
          .subscribe(response => {
            this.pageloaderService.setPageLoaderStatus(false);
            if (this.productSelectionModel.MdmSelection === 'DMPSKME') {
              if (response.users && response.users.length !== 0) {
                if (this.selectedAccID !== response.users[0].companyId) {
                  this.errorMessage = 'We were unable to complete your request.' +
                    'Please check that you have entered a valid Samsung Knox Mobile Enrollment ID.';
                  this.setupError = true;
                  this.pageloaderService.setPageLoaderStatus(true);
                  this.utilityService.loadFocusOnTop();
                } else {
                  this.setupError = false;
                  this.router.navigate(['/signupsetup/enrollmentoptions']);
                }
              } else {
                this.errorMessage = 'We were unable to complete your request. ' +
                  'Please check that you have entered a valid Samsung Knox Mobile Enrollment ID.';
                this.setupError = true;
                this.pageloaderService.setPageLoaderStatus(true);
                this.utilityService.loadFocusOnTop();
              }
            } else {
              this.setupError = false;
              this.router.navigate(['/signupsetup/enrollmentoptions']);
            }
          }, error => {
            this.pageloaderService.setPageLoaderStatus(true);
            this.setupError = true;
            this.handleError(error);
            this.utilityService.loadFocusOnTop();
          });
      } else {
        this.errorMessage = 'There was an error while processing your request. Please try again later.';
        this.setupError = true;
        this.pageloaderService.setPageLoaderStatus(true);
        this.utilityService.loadFocusOnTop();
      }
    }
    //google
    else if (this.selectedMdmDetails === 'DMPGZTP' && !this.isGoogleDisable) {
      sessionStorage.setItem('feFlag', "false");
      this.productSelectionService.setProdCode('ZTP');
      sessionStorage.removeItem('signedupData');
      sessionStorage.removeItem('failFromReviewFlag');
      sessionStorage.removeItem('enrollArray');
      const user = JSON.parse(sessionStorage.getItem('user'));
      const agreementID = user.user.agreement.id;
      if (this.showDiv.zteSign) {
        if (agreementID && this.selectService.value.googleIdZteName || agreementID && this.selectedAccID) {

          this.productSelectionService.zteIdValidation(this.selectedAccID ? this.selectedAccID : this.selectService.value.googleIdZteName, agreementID)
            .subscribe(response => {
              this.pageloaderService.setPageLoaderStatus(true);
              if (response.status == 'failure' || response.errorCode == 'E0404') {
                this.setupZteError = true;
              } else {
                // this.setupZteError = false;
                this.router.navigate(['/signupsetup/enrollmentoptions'], { state: { ztpIdres: response.ztpId } });
              }
            })
        } else {
          this.setupZteError = true;
        }
      } else {
        if (this.emmProductCode === 'DMPGZTP' && this.selectedAccID === null || this.selectedAccID === '') {
          this.pageloaderService.setPageLoaderStatus(true);
          this.errorMessage = 'Google Validation error has occured. Please enter valid Email id';
          this.setupError = true;
        } else {
          this.setupError = false;
          this.router.navigate(['/signupsetup/enrollmentoptions']);
        }
      }
    }
    //apple
    else if (this.selectedMdmDetails === 'DMPAABM' && !this.isAppleDisable) {
      if (this.callApple) {
        // if (event.target.id == "abmapplyacct") {
        //   sessionStorage.setItem('feFlag', "true");
        //   this.setupError = false;
        //   // this.router.navigate(['/abmfacilitatedenrollment']);
        //   this.isABMFE = true;
        // } else 
        if (this.appleValue) {
          sessionStorage.setItem('feFlag', "false");
          this.productSelectionService.setProdCode('ABM');

          //org id validation
          this.productSelectionService.orgIdValidation(this.appleValue)
            .subscribe(response => {
              this.showFanSelectionPage = true;
              this.showABMOrgIdPage = false;
              this.showABMYesContent = false;
              this.pageloaderService.setPageLoaderStatus(false);
              if (response) {
                if(response.status === 'success' && response.warning) {
                  this.abmOrgIdWarning = true;
                  this.abmOrgIdWarningMessage = response.warning;
                  let data = response;
                  this.tranid = data.deviceEnrollmentTransactionId;
                  sessionStorage.setItem('tranid', this.tranid);
                  this.pageloaderService.setPageLoaderStatus(true);
                  this.orgIdValidationLoading = true;
                  this.startPolling();
                }
                else if (response.status === 'success') {
                  let data = response;
                  this.tranid = data.deviceEnrollmentTransactionId;
                  //continue to next page as tran id validation call shifted to review page
                  this.setupError = false;
                  //new code start
                  sessionStorage.setItem('tranid', this.tranid);
                  this.pageloaderService.setPageLoaderStatus(true);
                  this.orgIdValidationLoading = true;
                  this.startPolling();
                  // setTimeout(() => {
                  //  this.productSelectionService.tranIdValidation(this.tranid, this.checkTransactionMock)
                  // this.productSelectionService.getCheckTransactionMockDetails()
                      // .subscribe(response => {
                      //   this.orgIdValidationLoading = false;
                      //   if (response.status === 'success') {
                      //     // this.status = true;
                      //     this.setupError = false;
                      //     this.showABMOrgIdPage = false;
                      //     this.router.navigate(['/productselection/enrollmentoptions']);
                      //   } else if (response.status === 'retry') {
                      //     //poll every 20 sec
                      //     this.orgIdValidationLoading = true;
                      //     let poll$ = interval(20000).pipe(
                      //       exhaustMap(obs =>
                      //         this.productSelectionService.tranIdValidation(this.tranid, this.checkTransactionMock)
                      //         // this.productSelectionService.getCheckTransactionMockDetails()
                      //         ),
                      //       tap(data => console.log(data))
                      //     );

                      //     const until$ = poll$.pipe(
                      //       filter(data => {
                      //         //let status: boolean;
                              
                      //         if (data.status === 'success') {
                      //           this.orgIdValidationLoading = false;
                      //           this.status = data.status;
                      //           this.setupError = false;
                      //           this.showABMOrgIdPage = false;
                      //           this.router.navigate(['/productselection/enrollmentoptions']);

                      //         } else if (data.status === 'failure') {
                      //           this.orgIdValidationLoading = false;
                      //           // this.pageloaderService.setPageLoaderStatus(true);
                      //           this.setupError = true;
                      //           this.errorMessage = this.abmOrgIdValidationError;
                      //           sessionStorage.setItem('failFromReviewFlag', 'true');
                      //           this.showABMOrgIdPage = true;
                      //           this.utilityService.loadFocusOnTop(); 
                      //           // return true;   
                      //         } else {
                      //           let time = Date.now() - this.timerStart;
                      //           // this.status = (time > 120000);
                      //           this.status = (time > 300000);
                      //           if (this.status) {
                      //             this.orgIdValidationLoading = false;
                      //             // this.pageloaderService.setPageLoaderStatus(true);
                      //             this.setupError = true;
                      //             this.errorMessage = this.abmOrgIdValidationTimeOutError;
                      //             // this.isDisabled = true;
                      //             sessionStorage.setItem('failFromReviewFlag', 'true');
                      //             this.utilityService.loadFocusOnTop();
                      //           }
                      //         }
                      //         return this.status;
                      //       })
                      //     );

                      //     const data$ = poll$.pipe(
                      //       takeUntil(until$))
                      //       .subscribe();

                      //     this.timerStart = Date.now();

                      //   } else if (response.status === 'failure') {
                      //     this.orgIdValidationLoading = false;
                      //     this.status = true;
                      //     // this.pageloaderService.setPageLoaderStatus(true);
                      //     this.setupError = true;
                      //     this.errorMessage = this.abmOrgIdValidationError;
                      //     this.showABMOrgIdPage = true;
                      //     // this.isDisabled = true;
                      //     sessionStorage.setItem('failFromReviewFlag', 'true');
                      //     this.utilityService.loadFocusOnTop();
                      //   }
                      // }, error => {
                      //   this.orgIdValidationLoading = false;
                      //   // this.pageloaderService.setPageLoaderStatus(true);
                      //   // this.isDisabled = true;
                      //   this.handleError('signup');
                      //   this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
                      //     'BC_Device_SignupSetup_Continue_Submit', 'SystemFailure',
                      //     'Failure_user', 'Continue', 'Body', '/businessconsole/signupsetup/enrollmentoptions');
                      // });
                  // }, 45000);

                  //new code end

                  //shift from here
                  // //transaction id validation
                  // let poll$ = interval(20000).pipe(
                  //   mergeMap(obs => 
                  //     this.productSelectionService.tranIdValidation(this.tranid)),
                  //     tap(data => console.log(data))
                  // );

                  // const until$ = poll$.pipe(
                  //   filter(data => {
                  //     let status: boolean;
                  //     if(data.status === 'success') {
                  //       status = true;
                  //       //this.pageloaderService.setPageLoaderStatus(true);
                  //       this.setupError = false;
                  //       this.router.navigate(['/signupsetup/enrollmentoptions']);

                  //     } else if (data.status === 'failure') {
                  //       status = true;
                  //       this.pageloaderService.setPageLoaderStatus(true);
                  //       this.setupError = true;
                  //       this.errorMessage = 'Apple Organization ID validation failed. Please try again.'
                  //       this.utilityService.loadFocusOnTop();

                  //     } else {
                  //       let time = Date.now() - this.timerStart;
                  //       status = (time > 60000);
                  //       if (status) {
                  //         this.pageloaderService.setPageLoaderStatus(true);
                  //         this.setupError = true;
                  //         this.errorMessage = data.ErrorDescription;
                  //         this.utilityService.loadFocusOnTop();
                  //       }
                  //     }
                  //     return status;
                  //   })
                  // );

                  // const data$ = poll$.pipe(
                  //   takeUntil(until$))
                  //   .subscribe();

                  // this.timerStart = Date.now();

                  //till here to be shifted

                } else {
                  this.pageloaderService.setPageLoaderStatus(true); 
                  this.appleOrgIdError = response.ErrorDescription;
                  this.errorMessage = this.appleOrgIdError;
                  this.setupError = true;
                  this.utilityService.loadFocusOnTop();
                }
              } else {
                this.pageloaderService.setPageLoaderStatus(true);
                this.errorMessage = 'Something went wrong. Please try again.';
                this.setupError = true;
                this.utilityService.loadFocusOnTop();
              }

            }, error => {
              this.pageloaderService.setPageLoaderStatus(true);
              this.setupError = true;
              //this.handleError(error);
              this.errorMessage = 'Apple Org ID validation failed. Please try again.';
              this.utilityService.loadFocusOnTop();
            });

        } else {
          this.setupError = true;
          this.errorMessage = 'Enter Apple Org ID and confirm.';
          this.pageloaderService.setPageLoaderStatus(true);
          this.utilityService.loadFocusOnTop();
        }

      } else {
        this.setupError = false;
        this.router.navigate(['/signupsetup/enrollmentoptions']);
      }
    }
    else {
      this.pageloaderService.setPageLoaderStatus(true);
      this.setupError = true;
      this.errorMessage = 'Something went wrong. Please try again later.';
      this.utilityService.loadFocusOnTop();
    }
  }

  handleError = (err) => {
    if (err) {
      if (err.status === 500) {
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
      } else if (err.status === 401) {
        this.errorMessage = 'Session expired, Please login again.';
        logoutCurrentUser(true);
      } else if (err.status === 400) {
        // this.errorMessage = 'Id is already in the system.';
        this.errorMessage = 'This ID is not valid.';
      } else if (err.status === 404) {
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
      } else if (this.signUpStatus === 'failure') { // remove this block after it is integrated wit the servce this is only for demo
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
      } else {
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
      }
      this.utilityService.loadFocusOnTop();
    }
  }

  dismissInfo() {
    this.setupError = false;
    this.showErrors = false;
    this.setupZteError = false;
    this.setupError2 = false;
    this.showGoogleCreationError = false;
  }

  createZTECustID() {
    this.showZTECustModal = true;
  }

  formZteReset() {
    this.setupZteError = false;
    this.selectService.controls['googleIdName'].reset();
    this.selectService.controls['googleIdNameConfirm'].reset();
    this.selectService.controls['googleIdZteName'].reset();
    this.selectService.controls['googleIdNameZteConfirm'].reset()
  }

  showDiv = {
    zteSign: true,
    zteSignup: false
  }

  disableTiles(){
    this.MdmSelection = "";
    let appleDEPFans = this.appleDEPFANs;
    let userFans = this.profileAndPermsInfo.fans;
    let accountSummaryData = sessionStorage.getItem("accountSummaryData") ? JSON.parse(sessionStorage.getItem("accountSummaryData")): null;
    let noOfFans = accountSummaryData.noOfFans;
    let fanInfoList = accountSummaryData.fanInfoList;
    let activeFans = fanInfoList.filter(fan => fan.accountStatus === 'ACTIVE' || fan.accountStatus === 'SIGNUP_INPROGRESS');
    let zteActiveFans = activeFans.filter(fan => fan.emmProductCode === 'DMPGZTP').map(fan => fan.fan);
    let kmeActiveFans = activeFans.filter(fan => fan.emmProductCode === 'DMPSKME').map(fan => fan.fan);
    let abmActiveFans = activeFans.filter(fan => fan.emmProductCode === 'DMPAABM').map(fan => fan.fan);
    let availableFansForZTE = [];//zteActiveFans.length == noOfFans ? [] : activeFans.filter(fan => (fan.emmProductCode == 'DMPGZTP' && fan.emmProductCode == 'DMPAABM') && (fan.emmProductCode != 'DMPSKME' && fan.emmProductCode == 'DMPAABM'));
    let availableFansForKME = [];//kmeActiveFans.length == noOfFans ? [] : activeFans.filter(fan => (fan.emmProductCode != 'DMPGZTP' && fan.emmProductCode == 'DMPAABM') && (fan.emmProductCode == 'DMPSKME' && fan.emmProductCode == 'DMPAABM'));
    let availableFansForABM = []; //abmActiveFans.length == noOfFans ? [] : activeFans.filter(fan => (fan.emmProductCode == 'DMPGZTP' || fan.emmProductCode == 'DMPSKME') && fan.emmProductCode !== 'DMPAABM');
    let availableFans = userFans.filter(fan => !activeFans.some(activeFan => activeFan.fan === fan));

    //available FANs for ABM
    if(abmActiveFans.length == noOfFans){
      availableFansForABM = [];
    }else{
       for(let i=0;i<userFans.length;i++){
          if(abmActiveFans.filter(f => f.fan == userFans[i]).length == 0){
            availableFansForABM.push(userFans[i]);
          }
      }
    }

    // Check each program independently - a fan in one program can still enroll in others
    if(zteActiveFans.length == noOfFans){
      availableFansForZTE = [];
    }else{
      availableFansForZTE = userFans.filter(fan => !zteActiveFans.includes(fan));
    }

    if(kmeActiveFans.length == noOfFans){
      availableFansForKME = [];
    }else{
      availableFansForKME = userFans.filter(fan => !kmeActiveFans.includes(fan));
    }
    //check appleDEP fans
    if(appleDEPFans.length > 0){
      availableFansForABM = availableFansForABM.filter(fan => !appleDEPFans.includes(fan.fan));
    }
    
    if(noOfFans == activeFans.length/3){
      //disabled all the tiles
      this.isABMFanAvailable = false;
      this.isZTEFanAvailable = false;
      this.isKMEFanAvailable = false;
      this.disableABM = true;
      this.disableKME = true;
      this.disableZTE = true;
    }else{
        if(availableFans.length > 0){
          this.isABMFanAvailable = true;
          this.isZTEFanAvailable = true;
          this.isKMEFanAvailable = true;
          this.disableABM = false;
          this.disableKME = false;
          this.disableZTE = false;
        }else{
            // Check each program independently
            if(availableFansForZTE.length == 0){
              this.isZTEFanAvailable = false;
              // this.isKMEFanAvailable = false;
              // this.isABMFanAvailable = true;
              this.disableZTE = true;  
              // this.MdmSelection = "DMPAABM";
            }
            if(availableFansForKME.length == 0){
              // this.isZTEFanAvailable = false;
              this.isKMEFanAvailable = false;
              // this.isABMFanAvailable = true;
              this.disableKME = true; 
              // this.MdmSelection = "DMPAABM";
            }
            if(availableFansForABM.length == 0){
              // this.isZTEFanAvailable = true;
              // this.isKMEFanAvailable = true;
              this.isABMFanAvailable = false;
              this.disableABM = true;  
              this.abmselected = false;
              // this.MdmSelection = "DMPGZTP";
            }
        }
    }
  }

  continueNext(page){
    this.isABMFE = false;
    this.abmNoStep3 = false;
    this.abmNoStep2 = false;
    this.abmNoStep4 = false;
    this.setupError = false;
      if(page == "step2"){
        this.isABMFE = true;
        this.abmNoStep2 = true;
      }else if(page == "step3"){
        this.isABMFE = true;
        this.abmNoStep3 = true;
        sessionStorage.setItem("newABMFlow", "true");
        this.getCompanyInformation();
        // this.companyName = userData.user.firstName + " " + userData.user.lastName
        // this.companyAddress = "";
        // this.companyDomain = "";
        // this.primaryEmail = userData.user.emailAddress;
      }else if(page == "step4"){
        sessionStorage.setItem('selectedProgram', 'ABM');
        sessionStorage.setItem('prevPage', 'step3');
        this.isABMFE = true;
        this.abmNoStep4 = true;
        let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
        productDetails.emmProductCode = this.MdmSelection; //this.selectedMdmDetails;
        productDetails.selectedAccID = this.selectedAccID;
        productDetails.signupEmmStatus = this.signupEmmStatus;

        sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
        this.router.navigate(['/productselection/enrollmentoptions']);
        
      }
  }

  backButton(page){
    this.isABMFE = false;
    this.abmNoStep3 = false;
    this.abmNoStep2 = false;
    this.abmNoStep4 = false;
      if(page == "step2"){
        this.isABMFE = true;
        this.abmNoStep2 = true;
      }else if(page == "step3"){
        this.isABMFE = true;
        this.abmNoStep3 = true;
      }else if(page == "step4"){
        this.isABMFE = true;
        // this.abmNoStep4 = true;

      }
  }

  confirmationPopup() {
    this.showConfirmationPopup = true;
  }

  closeOverviewModal() {
    this.showConfirmationPopup = false;
    this.processSignup = false;
    this.isConfirmErrorChecked = false;
  }

  continueErrorModal() {
    this.processSignup = true;
    this.showConfirmationPopup = false;
    this.disableZTE = true;
    this.disableKME = true;
    // if (this.emmProductCode === "DMPAABM" && (sessionStorage.getItem('feFlag') == "false") && this.processSignup === true) {
        // this.continueToFanSelection();
        this.productSelectionModel.MdmSelection = this.MdmSelection;
        sessionStorage.setItem('selectedProgram', 'ABM');
        sessionStorage.setItem('prevPage', 'step3');
        this.signupSetupSubmit({});
        // this.pageLoaderService.setPageLoaderStatus(false);
      // }
}

  continueToFanSelection() {
    this.showFanSelectionPage = true;
    this.showABMOrgIdPage = false;
    this.showABMYesContent = false;
    console.log(this.appleValue);
    // let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
    // productDetails.emmProductCode = this.productSelectionModel.MdmSelection; // this.selectedMdmDetails;
    // productDetails.selectedAccID = this.selectedAccID;
    // productDetails.signupEmmStatus = this.signupEmmStatus;

    // sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
    let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
      productDetails.emmProductCode = this.MdmSelection; //this.selectedMdmDetails;
      productDetails.selectedAccID = this.appleValue;//this.selectedAccID;
      productDetails.signupEmmStatus = this.signupEmmStatus;
      sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
    this.router.navigate(['/productselection/enrollmentoptions']);
    let enrollmentProductSelectionOption = sessionStorage.setItem('navigationPath', '/productselection/enrollmentoptions');
  }

  continueWithZTE() {
    
    // sessionStorage.removeItem('signupFanList');
    this.uncheckFansAndEnroll();
    sessionStorage.setItem("feFlag", "false");
    if(this.zteRadioSelected === 'Yes'){
      this.zteNoFlow = false;
      this.zteYesStep2 = true;
      this.zteYesStep1 = false;
      this.disableABM = true;
      this.disableKME = true;
    } else if(this.zteRadioSelected === 'No'){
      this.zteNoFlow = true;
      this.disableABM = true;
      this.disableKME = true;
      this.zteYesStep1 = false;
      this.zteNoStep2 = true;
      
    }
  }

  continueWithZTEYes(step) {
    this.zteYesStep1 = false;
    // if(step == 'zteStep2') {
    //   this.zteYesStep2 = true;
    // }
     if(step == 'zteStep3') {
      this.zteYesStep1 = false;
      this.zteYesStep3 = true;
      this.zteYesStep2 = false;
      this.disableABM = true;
      this.disableKME = true;
    }
    else if(step == 'zteStep4') {
      this.zteYesStep3 = true;
      this.disableABM = true;
      this.disableKME = true;
      let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
        productDetails.emmProductCode = this.MdmSelection; //this.selectedMdmDetails;
        // productDetails.selectedAccID = this.selectedAccID;
        productDetails.selectedAccID = this.googleIdValue;
        productDetails.signupEmmStatus = this.signupEmmStatus;

        
        const user = JSON.parse(sessionStorage.getItem('user'));
        const agreementID = user.user.agreement.id;
        this.pageloaderService.setPageLoaderStatus(false);
        //zte ID validation call here
        this.productSelectionService.zteIdValidation(productDetails.selectedAccID ? productDetails.selectedAccID : this.selectService.value.googleIdZteName, agreementID)
          .subscribe(response => {
            this.pageloaderService.setPageLoaderStatus(true);
            if (response.status == 'failure' || response.errorCode == 'E0404') {
              this.utilityService.loadFocusOnTop();
              this.setupZteError = true;
            } else {
              // this.setupZteError = false;
              this.zteYesStep3 = false;
              sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
              sessionStorage.setItem('selectedProgram', 'ZTE');
              sessionStorage.setItem('prevPage', 'zteStep3');
              this.router.navigate(['/productselection/enrollmentoptions'], { state: { ztpIdres: response.ztpId } });
            }
          });
    }
  }

  continueWithZTENo(step) {
     this.zteYesStep1 = false;
    if(step == 'zteStep3') {
      this.disableKME = true;
      this.disableABM = true;
      this.validateZTEmail();
    }else if(step == 'zteStep4') {
      this.zteNoFlow = true;
      this.zteNoStep3 = false;
      this.disableKME = true;
      this.disableABM = true;
      // let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
      //   productDetails.emmProductCode = this.MdmSelection; 
      //   productDetails.selectedAccID = this.googleValueConfirm ? this.googleValueConfirm : this.selectedDetails;
      //   productDetails.signupEmmStatus = this.signupEmmStatus;
      //   sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
        sessionStorage.setItem('selectedProgram', 'ZTE');
        sessionStorage.setItem('prevPage', 'zteStep3');

        this.router.navigate(['/productselection/enrollmentoptions']);
    }
  }

  backFromZTEYes(step) {
    if(step == 'zteStep2') {
      this.zteYesStep1 = true;
      this.zteYesStep2 = false;
      this.disableABM = this.isABMFanAvailable ? false : true;
      this.disableKME = this.isKMEFanAvailable ? false : true;
    }
    else if(step == 'zteStep3') {
      this.zteYesStep3 = false;
      this.zteYesStep2 = true;
      this.disableABM = true;
      this.disableKME = true;
    }
  }

  backFromZTENo(step) {
    if(step == 'zteStep2') {
      this.zteYesStep1 = true;
      this.zteNoStep2 = false;
      this.disableABM = this.isABMFanAvailable ? false : true;
      this.disableKME = this.isKMEFanAvailable ? false : true;
    }else if(step == 'zteStep3') {
      this.zteNoStep2 = true;
      this.zteNoStep3 = false;
    }
  }

  getCompanyInformation(){
    this.pageloaderService.setPageLoaderStatus(false);
    let d = new Date();
    let dd = ("0" + d.getDate()).slice(-2);
    let mm = ("0" + (d.getMonth() + 1)).slice(-2);
    let yy = String(d.getFullYear()).slice(-2);
    // let yy = d.getFullYear();
    let hh = ("0" + d.getHours()).slice(-2);
    let mms = ("0" + d.getMinutes()).slice(-2);
    let ss = ("0" + d.getSeconds()).slice(-2);
    let profileResp = sessionStorage.getItem('profileAndPermsInfo') ? JSON.parse(sessionStorage.getItem('profileAndPermsInfo')) : null; 
    if(profileResp){
      let fanId = profileResp.fans[0];
      let payload = {
        "requestId": "SAPMP-" + mm + dd + yy + hh + mms + ss,
        "sourceSystem": "SAPMP",
        "fanId": fanId
      }

      if(this.IFDMock){
        this.signupSetupService.getIFDMockDetails().subscribe(response => {
          console.log("IFD Mock response==>", response);
          this.processFanDetails(response);
        }, error => {
          this.pageloaderService.setPageLoaderStatus(true);
          this.handleError(error);
          this.utilityService.loadFocusOnTop();
        });
      }else{
        this.signupSetupService.getInquireFanDetails(payload).subscribe(response => {
          console.log("IFD response==>", response);
          this.processFanDetails(response);
        }, error => {
          this.pageloaderService.setPageLoaderStatus(true);
          this.handleError(error);
          this.utilityService.loadFocusOnTop();
        });
      }
    }
  }

  private processFanDetails(response: any): void {
    this.pageloaderService.setPageLoaderStatus(true);
    if (response.InquireFanDetailsResponse.operationStatus == 'SUCCESS') {
      let data = response.InquireFanDetailsResponse.FanDetails;
      if(data && data.AccountDetails && data.ATTContactDetails){
        this.companyName = this.FirstName + " " + this.LastName; //data.AccountDetails.orgName;
        this.companyAddress = data.AccountDetails.orgAddress1 + (data.AccountDetails.orgAddress2 ? data.AccountDetails.orgAddress2: "");
        this.companyDomain = "";
        this.primaryEmail = this.Email;//data.ATTContactDetails[0].email;

        let companyInfo = {
          companyName: this.companyName,
          companyAddress: this.companyAddress,
          companyDomain: this.companyDomain,
          primaryEmail: this.primaryEmail
        }
        sessionStorage.setItem('companyInfo', JSON.stringify(companyInfo));//store company information in session storage
      }
    }else{

    }
  }

  showABMOrgIdPageFunc(status: boolean){
    this.showBackButton = true;
    if(this.abmselected && status){
      this.showABMOrgIdPage = true;
      this.showBackButton = false;
    }else{
      this.showABMOrgIdPage = false;
      
    }
  }

  continueWithKME(page){
    // sessionStorage.removeItem('signupFanList');
    this.uncheckFansAndEnroll();
    sessionStorage.setItem("feFlag", "false");
    this.kmeselected= true;
    this.kmeYesStep1 = false;
    this.kmeYesStep2 = false;
    this.kmeYesStep3 = false;
    this.kmeYesStep4 = false;
    this.kmeNoStep1 = false;
    let kmeOptions;
    if( this.kmeRadioSelected == "No"){
      this.kmeNoStep1 = true;
      this.disableZTE = true;
      this.disableABM = true;
    }else if(page == "kmeStep2" && this.kmeRadioSelected == "Yes"){
      this.kmeYesStep2 = true;
      this.disableZTE = true;
      this.disableABM = true;
    }else if(page == "kmeStep3" && this.kmeRadioSelected == "Yes"){
      this.kmeYesStep3 = true;
      this.disableZTE = true;
      this.disableABM = true;
    }else if(page == "kmeStep4" && this.kmeRadioSelected == "Yes"){
      this.kmeYesStep3 = true;
      this.disableZTE = true;
      this.disableABM = true;
      let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
      productDetails.emmProductCode = this.MdmSelection; //this.selectedMdmDetails;
      productDetails.selectedAccID = this.selectedDetailsKme ? this.selectedDetailsKme : this.samsungValue; //this.selectedAccID;
      productDetails.signupEmmStatus = this.signupEmmStatus;

      this.pageloaderService.setPageLoaderStatus(false);
      //kme id validation call here
        this.productSelectionService.signupDetails(productDetails.emmProductCode, productDetails.selectedAccID)
          .subscribe(response => {
            this.pageloaderService.setPageLoaderStatus(true);
            if (this.MdmSelection === 'DMPSKME') {
              if (response.users && response.users.length !== 0) {
                if (productDetails.selectedAccID !== response.users[0].companyId) {
                  this.kmeYesStep3 = true;
                  this.errorMessage = 'We were unable to complete your request.' +
                    'Please check that you have entered a valid Samsung Knox Mobile Enrollment ID.';
                  this.setupError = true;
                  this.pageloaderService.setPageLoaderStatus(true);
                  this.utilityService.loadFocusOnTop();
                } else {
                  sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
                  sessionStorage.setItem('selectedProgram', 'KME');
                  sessionStorage.setItem('prevPage', 'kmeStep3');
                  this.kmeYesStep3 = false;
                  this.setupError = false;
                  this.router.navigate(['/productselection/enrollmentoptions']);
                }
              } else {
                this.kmeYesStep3 = true;
                this.errorMessage = 'We were unable to complete your request. ' +
                  'Please check that you have entered a valid Samsung Knox Mobile Enrollment ID.';
                this.setupError = true;
                this.pageloaderService.setPageLoaderStatus(true);
                this.utilityService.loadFocusOnTop();
              }
            } else {
              sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
              sessionStorage.setItem('selectedProgram', 'KME');
              sessionStorage.setItem('prevPage', 'kmeStep3');
              this.kmeYesStep3 = false;
              this.setupError = false;
              this.router.navigate(['/productselection/enrollmentoptions']);
            }
          }, error => {
            this.kmeYesStep3 = true;
            this.pageloaderService.setPageLoaderStatus(true);
            this.setupError = true;
            this.handleError(error);
            this.utilityService.loadFocusOnTop();
          });
    }


  }

  goToPrevPage(page){
    this.kmeNoStep1 = false;
      if(page == "kmeStep1"){
        this.kmeYesStep1 = true;
        this.kmeYesStep2 = false;
        this.disableZTE = this.isZTEFanAvailable ? false : true;
        this.disableABM = this.isABMFanAvailable ? false : true;
      }else if(page == "kmeStep2"){
        this.kmeYesStep2 = true;
        this.kmeYesStep3 = false;
        this.kmeYesStep1 = false;
        this.disableZTE = true;
        this.disableABM = true;
      }else if(page == "kmeStep3"){
        this.kmeYesStep3 = true;
        // this.kmeYesStep4 = false;
        this.kmeYesStep1 = false;
        this.kmeYesStep2 = false;
        this.disableZTE = true;
        this.disableABM = true;
      }
}

uncheckFansAndEnroll(){
  let signupFanList = sessionStorage.getItem('signupFanList') ? JSON.parse(sessionStorage.getItem('signupFanList')) : null;
  let signedupData = sessionStorage.getItem('signedupData') ? JSON.parse(sessionStorage.getItem('signedupData')) : null; 
  let selectedSignupFanList = sessionStorage.getItem('selectedSignupFanList') ? JSON.parse(sessionStorage.getItem('selectedSignupFanList')) : null;
  let enrollArray = sessionStorage.getItem('enrollArray') ? JSON.parse(sessionStorage.getItem('enrollArray')) : null;
  if(signupFanList){
      signupFanList.selectedEnrollFans = [];
      signupFanList.enrollArray = [];
      sessionStorage.setItem('signupFanList', JSON.stringify(signupFanList));
    }

  if(signedupData){
      signedupData = [];
      sessionStorage.setItem('signedupData', JSON.stringify(signedupData));
    }

  if(selectedSignupFanList){
      selectedSignupFanList = [];
      sessionStorage.setItem('selectedSignupFanList', JSON.stringify(selectedSignupFanList));
    }

  if(enrollArray){
      enrollArray = [];
      sessionStorage.setItem('enrollArray', JSON.stringify(enrollArray));
    }
}

showtooltip(status, type){
  // this.showDisableTooltip = status;
  let sourceDivPos:any = {};
 
  if(type == "zte" && this.disableZTE && !this.isZTEFanAvailable){
    this.targetDiv.nativeElement.style.display = status ? 'block' : 'none';
    sourceDivPos = this.sourceZTEDiv.nativeElement.getBoundingClientRect();
    this.targetDivStyle = {
      position: 'fixed',
      top: `${sourceDivPos.top+100}px`,
      left: `${sourceDivPos.left-35}px`
    };
  }else if(type == "kme" && this.disableKME && !this.isKMEFanAvailable){
    this.targetDiv.nativeElement.style.display = status ? 'block' : 'none';
    sourceDivPos = this.sourceKMEDiv.nativeElement.getBoundingClientRect();
    this.targetDivStyle = {
      position: 'fixed',
      top: `${sourceDivPos.top+100}px`,
      left: `${sourceDivPos.left-35}px`
    };
  }else if(type == "abm" && this.disableABM && !this.isABMFanAvailable){
    this.targetDiv.nativeElement.style.display = status ? 'block' : 'none';
    sourceDivPos = this.sourceABMDiv.nativeElement.getBoundingClientRect();
    this.targetDivStyle = {
      position: 'fixed',
      top: `${sourceDivPos.top+100}px`,
      left: `${sourceDivPos.left-35}px`
    };
  }

  // Set the position of the target div
  

  console.log('Source Div Position:', sourceDivPos);
}

startPolling() {
  this.orgIdValidationLoading = true;
  const pollingInterval = 20000; // 20 seconds
  const maxPollingTime = 300000; // 5 minutes (300,000 ms)
  const startTime = Date.now();
 
  this.stopPolling$ = new Subject<void>();
 
  interval(pollingInterval)
    .pipe(
      exhaustMap(() =>
        this.productSelectionService.tranIdValidation(this.tranid, this.checkTransactionMock).pipe(
          tap((response) => {
            console.log('API Response:', response);
 
            if (response.status === 'success') {
              this.orgIdValidationLoading = false;
              this.setupError = false;
              this.setupError2 = false;
              this.stopPolling$.next(); // Stop polling
              this.stopPolling$.complete();
              console.log("polling success response");
              this.router.navigate(['/productselection/enrollmentoptions']);
            } else if (response.status === 'failure') {
              this.orgIdValidationLoading = false;
              this.setupError2 = true;
              this.errorMessage = this.abmOrgIdValidationError;
              sessionStorage.setItem('failFromReviewFlag', 'true');
              this.utilityService.loadFocusOnTop();
              this.showABMYesContent = false;
              this.showABMOrgIdPage = true;
              this.stopPolling$.next(); // Stop polling
              this.stopPolling$.complete();
              console.log("polling failure response");
            } else if (response.status === 'retry') {
              const elapsedTime = Date.now() - startTime;
              if (elapsedTime >= maxPollingTime) {
                this.orgIdValidationLoading = false;
                this.setupError2 = true;
                this.errorMessage = this.abmOrgIdValidationTimeOutError;
                sessionStorage.setItem('failFromReviewFlag', 'true');
                this.showABMYesContent = false;
                this.showABMOrgIdPage = true;
                this.utilityService.loadFocusOnTop();
                this.stopPolling$.next(); // Stop polling
                this.stopPolling$.complete();
                console.log("polling retry response");
              }
            }
          })
        )
      ),
      takeUntil(this.stopPolling$) // Stop polling when stopPolling$ emits
    )
    .subscribe({
      error: (err) => {
        console.error('Polling Error:', err);
        this.orgIdValidationLoading = false;
        // this.setupError = true;
        // this.errorMessage = 'An error occurred during polling.';
        this.handleError('signup');
        this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
          'BC_Device_SignupSetup_Continue_Submit', 'SystemFailure',
          'Failure_user', 'Continue', 'Body', '/businessconsole/signupsetup/enrollmentoptions');
      }
    });
}

validateZTEmail() {
  this.dismissInfo();
  const user = JSON.parse(sessionStorage.getItem('user'));
  const agreementID = user.user.agreement.id;
  let selectedAccID = this.googleValueConfirm ? this.googleValueConfirm : this.selectedDetails;
  this.pageloaderService.setPageLoaderStatus(false);
  this.signupSetupService.createZtpAccount(selectedAccID, agreementID)
  .subscribe(response => {
    this.pageloaderService.setPageLoaderStatus(true);
    if (response.status === 'success') {
      this.zteNoStep3 = true;
      this.zteNoStep2 = false;
      let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
      productDetails.emmProductCode = 'DMPGZTP';
      productDetails.selectedAccID = response.ztpId;
      productDetails.signupEmmStatus = 'initial';
      sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
    }else{
      this.zteNoStep3 = false;
      this.zteNoStep2 = true;
      this.showGoogleCreationError = true;
      this.showErrors = true;
      this.errorMessage = response.error;
      this.utilityService.loadFocusOnTop();
    }
  }, (error) => {
    this.pageloaderService.setPageLoaderStatus(true);
    this.showGoogleCreationError = true;
    this.showErrors = true;
    // this.errorMessage = response.error;
    this.utilityService.loadFocusOnTop();
  });
}

}
